const { tax, principal, insurance } = require('./math');

const mortgageMath = {
  tax,
  principal,
  insurance,
};

export { mortgageMath };
